import { ChefHat, Fish, Flame, Leaf, MilkOff, Nut, Sparkles, Sprout, Star, WheatOff } from "lucide-react";

const LABEL_STYLE = {
  bestseller: ["#f59e0b", Star],
  new: ["#3b82f6", Sparkles],
  spicy: ["#ef4444", Flame],
  chef_pick: ["var(--wt-primary)", ChefHat],
};
const DIET_ICON = { vegetarian: Leaf, vegan: Sprout, gluten_free: WheatOff, contains_nuts: Nut, seafood: Fish, dairy_free: MilkOff };

export const LabelBadges = ({ labels = [], t, className = "" }) => {
  if (!labels.length) return null;
  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`}>
      {labels.map((l) => {
        const [color, Icon] = LABEL_STYLE[l] || ["#71717a", Star];
        return (
          <span key={l} data-testid={`badge-${l}`} className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-bold text-white shadow-md" style={{ background: color }}>
            <Icon className="h-3 w-3" />
            {t(`label.${l}`)}
          </span>
        );
      })}
    </div>
  );
};

export const DietTags = ({ tags = [], t }) => {
  if (!tags.length) return null;
  return (
    <div className="flex flex-wrap gap-2">
      {tags.map((d) => {
        const Icon = DIET_ICON[d] || Leaf;
        return (
          <span key={d} data-testid={`diet-${d}`} className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium" style={{ borderColor: "color-mix(in srgb, var(--wt-text) 15%, transparent)" }}>
            <Icon className="h-3.5 w-3.5" style={{ color: "var(--wt-secondary)" }} />
            {t(`diet.${d}`)}
          </span>
        );
      })}
    </div>
  );
};
